module.exports = __webpack_public_path__ + "static/media/hammer.e5bd88ba.svg";